'use client'

import { isStudioLanguageForUrlSyncEnabled } from '@repo/studio-i18n-hooks/resolve-studio-language-for-url'
import { usePersistStudioLanguageCookie } from '@repo/studio-i18n-hooks/use-persist-studio-language-cookie'
import { useStudioLanguageBroadcast } from '@repo/studio-i18n-hooks/use-studio-language-broadcast'
import {
  useStudioLanguageForUrlQuery,
  useStudioLanguageForUrlSyncReady,
} from '@repo/studio-i18n-hooks/use-studio-language-for-url'
import { useSyncLocaleUrl } from '@repo/studio-i18n-hooks/use-sync-locale-url'

export function LocaleUrlSync() {
  const languageForUrlQuery = useStudioLanguageForUrlQuery()
  const urlSyncReady = useStudioLanguageForUrlSyncReady()

  const enabled = isStudioLanguageForUrlSyncEnabled({
    isSuccess: languageForUrlQuery.isSuccess,
    urlSyncReady,
  })

  useStudioLanguageBroadcast()
  usePersistStudioLanguageCookie(languageForUrlQuery.data, { enabled })
  useSyncLocaleUrl(languageForUrlQuery.data, { enabled })

  return null
}
